import { Reveal } from "./Reveal";
import { Lightbulb, Layers, Users, Wrench } from "lucide-react";

const PILLARS = [
    {
        icon: Lightbulb,
        title: "Practical Technology Solutions",
        text: "Technology services aligned with your actual needs, project requirements, and budget — not one-size-fits-all packages.",
        testid: "benefit-card-practical",
    },
    {
        icon: Layers,
        title: "Integrated Service Offerings",
        text: "Mobile platforms, software, networking, security systems, and connectivity — brought together in one service portfolio.",
        testid: "benefit-card-integrated",
    },
    {
        icon: Users,
        title: "Customer-Focused Approach",
        text: "Clear communication, project coordination, and close attention to your requirements from start to finish.",
        testid: "benefit-card-customer",
    },
    {
        icon: Wrench,
        title: "Technical Implementation",
        text: "A professional focus on proper installation, configuration, and technology deployment for dependable results.",
        testid: "benefit-card-technical",
    },
];

export default function WhyChooseUs() {
    return (
        <section
            id="why"
            data-testid="why-choose-section"
            className="bg-brand-50/60 py-20 lg:py-32"
        >
            <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
                <Reveal className="mb-14 max-w-2xl">
                    <span className="font-mono text-xs font-semibold uppercase tracking-[0.2em] text-brand">
                        Why Choose Lynxtech
                    </span>
                    <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-navy sm:text-4xl">
                        A dependable partner across the technology you rely on.
                    </h2>
                    <p className="mt-4 text-base leading-relaxed text-slate-600">
                        We keep our promises factual and our work practical. Here is
                        what guides the way we serve every client.
                    </p>
                </Reveal>

                <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
                    {PILLARS.map((p, i) => (
                        <Reveal key={p.title} delay={i * 0.08}>
                            <article
                                data-testid={p.testid}
                                className="group h-full rounded-2xl border border-slate-200 bg-white p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-brand/40 hover:shadow-[0_20px_45px_rgba(2,132,199,0.12)] sm:p-8"
                            >
                                <div className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-brand-50 text-brand transition-colors group-hover:bg-brand group-hover:text-white">
                                    <p.icon className="h-6 w-6" />
                                </div>
                                <h3 className="font-display text-xl font-semibold text-navy">
                                    {p.title}
                                </h3>
                                <p className="mt-3 text-sm leading-relaxed text-slate-600">
                                    {p.text}
                                </p>
                            </article>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
